import { useState } from "react";
import Button from "../../../../ui/Button";
import { useCustomerAttachmentPrint } from "../../../../utils/customerAttachment.utils";
import { PrintIcon } from "../../../../utils/icon.utils";
import VehicleInventoryPrintModal from "./VehicleShowroomWorksPrintModal";
import { printDate } from "../../../../utils/date.utils";
import { toast } from "react-toastify";

export default function VehicleShowroomWorksPrint({ data }) {
  const [printModal, setPrintModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  const printToggle = () => {
    setPrintModal((prev) => !prev);
  };

  // print money receipt
  const { printParams, setPrintParams, printCount, setPrintCount, printLoading } =
    useCustomerAttachmentPrint();

  const onPrint = () => {
    printToggle();
  };

  const handlePrint = (submittedData) => {
    const { print_date, print_pad_type } = submittedData;
    const id = data?.caid ? data.caid : "";

    if (!id) {
      toast.warning("Attachement missing!");
    }

    setPrintParams({
      caid: id,
      time: printCount,
      printDate: print_date ? printDate(print_date) : null,
      print_pad_type
    });
    setPrintCount((prev) => prev + 1);
  };

  // handle button click
  function handleButton(name, cb) {
    // set modal title
    setModalTitle(name);
    // call the button function
    cb();
  }
  return (
    <>
      <Button
        onClick={() => handleButton("Inventory", onPrint)}
        name={printLoading ? "Printing..." : "Print"}
        icon={PrintIcon}
        color="info"
        disabled={printLoading}
      />
      {printModal && (
        <VehicleInventoryPrintModal
          modal={printModal}
          toggle={printToggle}
          printDate={printParams.printDate}
          handlePrint={handlePrint}
          modalTitle={modalTitle}
        />
      )}
    </>
  );
}
